<template>
    <div>
        <el-dialog
                :title="title"
                width="40%"
                :visible.sync="isShowDialog"
                @close="closeDialog">
            <el-form ref="editCoupon" :model="coupon" :rules='rules' label-width='100px'>
                <el-row>
                    <el-col>
                        <el-form-item label='优惠券名称:' prop='couponName'>
                            <el-input v-model='coupon.couponName' placeholder='请输入优惠券名称'/>
                        </el-form-item>
                    </el-col>

                    <el-col>
                        <el-form-item label='优惠券面额:' prop='couponPrice'>
                            <el-input v-model='coupon.couponPrice' placeholder='只能输入数字，保留一位小数'/>
                        </el-form-item>
                    </el-col>

                    <el-col>
                        <el-form-item label='使用有效期:' prop='couponType'>
                            <el-radio-group v-model='coupon.couponType' @change="radioChange">
                                <el-radio label="DAY" class="creat_coupon_radio_top">
                                    <el-form-item class="creat_coupon_start_picker" prop='effectiveDay'>
                                        发券当日起
                                        <el-input type="text"
                                                  oninput="value = Number(value) || 0"
                                                  v-model='coupon.effectiveDay'
                                                  placeholder='请输入天数数字'
                                                  class="creat_coupon_input"/>
                                        天内可用
                                    </el-form-item>
                                </el-radio>
                                <el-radio label="TIME" class="creat_coupon_radio">
                                    <el-form-item class="creat_coupon_start_picker" prop='startTime'>
                                        <el-date-picker
                                                v-model='coupon.startTime'
                                                placeholder='开始时间'
                                                type="datetime"
                                                value-format="timestamp"
                                                @input="$forceUpdate()"
                                        />
                                        ~
                                    </el-form-item>
                                    <el-form-item class="creat_coupon_end_picker" prop='endTime'>
                                        <el-date-picker
                                                v-model='coupon.endTime'
                                                placeholder='结束时间'
                                                type="datetime"
                                                value-format="timestamp"
                                                @input="$forceUpdate()"
                                        />
                                    </el-form-item>
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label='适用产品:' prop='applicableProduct'>
                            <el-select v-model='coupon.applicableProduct' placeholder='选择产品'>
                                <el-option
                                        v-for="item in enumApplicableProduct"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col>
                        <el-form-item label='适用对象:' prop='applicableTarget'>
                            <el-select v-model='coupon.applicableTarget' placeholder='选择可用对象'>
                                <el-option
                                        v-for="item in enumApplicableTarget"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
            <div class='dialog-footer'>
                <el-button @click='isShowDialog = false'>取 消</el-button>
                <el-button @click='editCoupon'>确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
  import { couponRules } from '@/js/rules'
  import { editCoupon } from '@/api/coupon/coupon'
  import { getData } from '@/utils/code'
  import { enumApplicableProduct, enumApplicableTarget } from '@/js/enum'

  export default {
    name: 'editCoupon',
    data() {
      return {
        title: '',
        fromData: [],
        isShowDialog: false,
        total: 0,
        queryInfo: {
          current: 1,
          size: 10,
          keyword: ''
        },
        coupon: {
          couponType: 'DAY'
        },
        enumApplicableProduct,
        enumApplicableTarget,
        rules: couponRules
      }
    },
    created() {
    },
    methods: {
      radioChange() {
        if (this.coupon.couponType === 'DAY') {
          couponRules.effectiveDay[0].required = true
          couponRules.startTime[0].required = false
          couponRules.endTime[0].required = false
        } else {
          couponRules.effectiveDay[0].required = false
          couponRules.startTime[0].required = true
          couponRules.endTime[0].required = true
        }
      },
      showDialog(title, row) {
        this.title = title
        if (row) {
          this.coupon = row
          this.coupon.startTime = new Date(row.startTime).getTime()
          this.coupon.endTime = new Date(row.endTime).getTime()
        }
        this.radioChange()
        this.isShowDialog = true
      },
      // 关闭页面
      closeDialog() {
        this.isShowDialog = false
        couponRules.effectiveDay[0].required = true
        couponRules.startTime[0].required = false
        couponRules.endTime[0].required = false
        this.coupon = { couponType: 'DAY' }
        this.$refs['editCoupon'].resetFields()
      },
      // 添加或更新优惠券
      editCoupon() {
        this.$refs.editCoupon.validate(async (valid) => {
          if (!valid) return
          editCoupon(this.coupon).then(res => {
            let data = getData(res)
            if (data !== null) {
              this.$emit('refresh-list')
              this.isShowDialog = false
            }
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
    .creat_coupon_radio_top {
        width: 90%;
        margin-top: 10px
    }
    .creat_coupon_radio {
        margin-top: 25px
    }
    .creat_coupon_input {
        width: 130px;
        margin: 0px 5px;
    }
    .creat_coupon_start_picker {
        margin: -25px 0px 0px 20px
    }
    .creat_coupon_end_picker {
        margin: -33px 0px 0px 260px;
    }
    /deep/.creat_coupon_start_picker{
        .el-form-item__error{
            padding-left: 90px;
        }
    }
</style>